export default __webpack_public_path__ + "static/media/exclusion.6509c695.svg";